import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import {
  getDoc,
  collection,
  getDocs,
  doc
} from "firebase/firestore";
import { db } from "../firebase";

export default function ListeModelesParMarque() {
  const { marqueId } = useParams();
  const [marqueNom, setMarqueNom] = useState("");
  const [modeles, setModeles] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const marqueRef = doc(db, "marques", marqueId);
      const marqueSnap = await getDoc(marqueRef);
      if (marqueSnap.exists()) {
        setMarqueNom(marqueSnap.data().nom);
        const modelesSnap = await getDocs(collection(db, `marques/${marqueId}/modeles`));
        const data = modelesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setModeles(data);
      }
    };
    fetchData();
  }, [marqueId]);

  return (
    <div className="container py-4">
      
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <h2 className="fw-bold text-primary mb-2">Modèles {marqueNom && `de ${marqueNom}`}</h2>
        <Link to="/marques" className="btn btn-outline-secondary">← Retour aux marques</Link>
      </div>

      <div className="row g-4">
        {modeles.map((m) => (
          <div key={m.id} className="col-md-6 col-lg-4">
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5 className="card-title text-dark">{m.nom}</h5>
                <ul className="list-unstyled small text-muted mb-0">
                  <li><strong>Moteur :</strong> {m.ficheTechnique?.moteur || "N/A"}</li>
                  <li><strong>Carburant :</strong> {m.ficheTechnique?.carburant || "N/A"}</li>
                  <li><strong>Transmission :</strong> {m.ficheTechnique?.transmission || "N/A"}</li>
                </ul>
              </div>
            </div>
          </div>
        ))}
        {modeles.length === 0 && (
          <div className="col-12">
            <p className="text-muted text-center">Aucun modèle disponible pour cette marque.</p>
          </div>
        )}
      </div>
    </div>
  );
}